export const version = '2.38.4';
//# sourceMappingURL=version.js.map